import * as React from 'react'
import { IProps } from '../../types'

const Checked = ({ className }: IProps) => (
  <div className={className}>
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4281 2.15586C12.2811 1.3859 13.5833 1.46138 14.3449 2.33131C15.1159 3.21251 15.0352 4.56466 14.1723 5.34345L14.1722 5.34358L6.97232 11.8437L6.97224 11.8437C6.5898 12.1891 6.10079 12.375 5.60017 12.375C5.53506 12.375 5.4661 12.3714 5.39263 12.3641C4.82241 12.3058 4.29618 12.0065 3.94523 11.5317C3.94522 11.5317 3.94521 11.5317 3.9452 11.5317C3.94514 11.5316 3.94509 11.5315 3.94504 11.5314L1.54528 8.28165L1.54523 8.28159C0.847224 7.33648 1.0408 5.99603 1.96168 5.29503C2.87293 4.60136 4.1654 4.78393 4.85512 5.7181L4.85525 5.71828L5.16853 6.14241L5.90595 7.14078L6.82728 6.30909L11.4281 2.15586Z"
        fill="#6D1CF0"
        stroke="white"
        strokeWidth="2.25"
      />
    </svg>
  </div>
)

export default Checked



// WEBPACK FOOTER //
// ./src/components/Icons/components/Checked/index.tsx